export default "__VITE_ASSET__D0$qJa_a__"